import ProfileMenu from '@/core/components/ProfileMenu/ProfileMenu';

export default ProfileMenu;
